import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
import InputTextAreaSF from '../../../../widgets/form/InputTextAreaSF'
import './RepaymentRemarksModal.css'

const PrepaymentWaiverModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted, status,
    // event handlers
    onSubmit, onCancelClick,
    // fields
    leviedAmount, onLeviedAmountChange, leviedAmountError, setLeviedAmountError,
    leviedReason, onLeviedReasonChange, leviedReasonError, setLeviedReasonError,
    waivedAmount, onWaivedAmountChange, waivedAmountError, setWaivedAmountError,
    waivedReason, onWaivedReasonChange, waivedReasonError, setWaivedReasonError
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Adjustments'
        buttonLabel='Save'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='leviedAmount' maxLength={12}
            label='Levied amount'
            value={leviedAmount} onChange={onLeviedAmountChange}
            error={leviedAmountError} setError={setLeviedAmountError}
        />
        <InputTextAreaSF type='text' name='leviedReason' maxLength={200}
            label='Levied reason'
            value={leviedReason} onChange={onLeviedReasonChange}
            error={leviedReasonError} setError={setLeviedReasonError}
        />
        <InputTextSF type='text' name='waivedAmount' maxLength={12}
            label='Waived amount'
            value={waivedAmount} onChange={onWaivedAmountChange}
            error={waivedAmountError} setError={setWaivedAmountError}
        />
        <InputTextAreaSF type='text' name='waivedReason' maxLength={200}
            label='Waived reason'
            value={waivedReason} onChange={onWaivedReasonChange}
            error={waivedReasonError} setError={setWaivedReasonError}
        />
    </ModalFormUI>

export default PrepaymentWaiverModalUI
